import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Header from "./components/site/Header";
import Hero from "./components/site/Hero";
import About from "./components/site/About";
import Expertise from "./components/site/Expertise";
import Attorneys from "./components/site/Attorneys";
import Engagements from "./components/site/Engagements";
import Locations from "./components/site/Locations";
import Contact from "./components/site/Contact";
import Footer from "./components/site/Footer";

function Home() {
  return (
    <div className="App">
      <Header />
      <main>
        <Hero />
        <About />
        <Expertise />
        <Attorneys />
        <Engagements />
        <Locations />
        <Contact />
      </main>
      <Footer />
      <Toaster
        position="top-center"
        richColors
        toastOptions={{
          style: {
            fontFamily: "Manrope, sans-serif",
            borderRadius: "2px",
          },
        }}
      />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
